(() => {
  const instances = new WeakMap();

  function init(root) {
    if (!(root instanceof HTMLElement) || instances.has(root)) return;
    const filter = root.querySelector('[data-scooter-table-filter]');
    const input = root.querySelector('[data-scooter-table-search]');
    const clear = root.querySelector('[data-scooter-table-clear]');
    const count = root.querySelector('[data-scooter-table-count]');
    const empty = root.querySelector('[data-scooter-table-empty]');
    const rows = [...root.querySelectorAll('[data-armor-dosing-row][data-device="Electric scooter"]')];
    if (!filter || !input || !clear || !count || !empty || rows.length === 0) return;

    const controller = new AbortController();
    const update = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      for (const row of rows) {
        const searchable = `${row.dataset.model || ''} ${row.dataset.tire || ''}`.toLocaleLowerCase();
        const matches = query === '' || searchable.includes(query);
        row.hidden = !matches;
        if (matches) visible += 1;
      }
      count.textContent = `${visible} scooter ${visible === 1 ? 'amount' : 'amounts'}`;
      clear.hidden = query === '';
      empty.hidden = visible !== 0;
    };

    input.addEventListener('input', update, { signal: controller.signal });
    clear.addEventListener('click', () => {
      input.value = '';
      update();
      input.focus();
    }, { signal: controller.signal });

    filter.hidden = false;
    update();
    instances.set(root, controller);
  }

  function unload(root) {
    if (!(root instanceof HTMLElement)) return;
    const controller = instances.get(root);
    if (!controller) return;
    controller.abort();
    instances.delete(root);
  }

  document.querySelectorAll('[data-armor-device-guide]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-armor-device-guide]')));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target.querySelector('[data-armor-device-guide]')));
})();
